export const discoveryLinkText = {
    color: 'var(--ecal-lightgrey)',
    fontSize: '0.875rem',
    mt: 0.5,
};

export const discoveryLink = {
    color: 'var(--ecal-lightblue)',
    textDecoration: 'none',
    '&:hover': { textDecoration: 'underline' },
};

// Sits inline with the "My subscriptions" heading, pushed to the far right
// by the flex row it's nested in (renderHeader) — not its own full-width bar.
export const loadMoreBar = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
};

export const loadMoreText = {
    color: 'var(--ecal-lightgrey)',
    fontSize: '0.8125rem',
};

export const loadMoreButton = {
    padding: '8px 20px',
    background: 'linear-gradient(90deg, #0078FF 0%, #00D7FF 100%)',
    borderRadius: '999px',
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: 'var(--ecal-white)',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    whiteSpace: 'nowrap',
    transition: 'filter 0.2s ease',
    '&:hover': { filter: 'saturate(1.15)' },
    '&:disabled': { cursor: 'default', opacity: 0.6, filter: 'none' },
};
